export default {
    type: 'set',
    format: {},
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Played With',
        category: ['User', 'Plays'],
        description: 'Players you have logged plays with.',
        summarise: {
            prefix: 'Played with',
            template: {
                match: {
                    '=': 'Played with {value}',
                    '!=': 'Not played with {value}'
                },
                oneof: {
                    '=': 'Played with one of {value}',
                    '!=': 'Not played with oen of {value}'
                },
                someof: {
                    '=': 'Played with {tolerance} of {value}',
                    '!=': 'Not played with {tolerance} of {value}',
                    '>=': 'Played with at least {tolerance} of {value}',
                    '>': 'Not played with more than {tolerance} of {value}',
                    '<=': 'Played with at most {tolerance} of {value}',
                    '<': 'Played with less than {tolerance} of {value}'
                },
                allof: {
                    '=': 'Played with all of {value}',
                    '!=': 'Not played with any of {value}'
                }
            }
        },
        unit: 'player'
    },
    rules: {
        linked: [],
        legacy: ['play.players.required']
    }
}